import React, { useState, useEffect, useMemo } from 'react';
import { Navigate, useRoutes, useLocation } from 'react-router-dom';
import { CityService } from './application/CityService';
import LoadingSpinner from './components/LoadingSpinner';

// 導入所有組件
import DashboardLayout from './layouts/dashboard';
import LogoOnlyLayout from './layouts/LogoOnlyLayout';
import Analyze from './pages/Analyze';
import Login from './pages/Login';
import Register from './pages/Register';
import DashboardApp from './pages/DashboardApp';
import Info from './pages/Info';
import User from './pages/User';
import Logout from './pages/Logout';
import NotFound from './pages/Page404';
import Binging from './pages/Binging';
import MobileDVR from './pages/MobileDVR';
import DVR from './pages/DVR';
import SystemHealth from './pages/Health';
import Emissions from './pages/Emissions';

function useQuery() {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
}

export default function Router() {
  const [cityPaths, setCityPaths] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const fetchCityPaths = async () => {
      try {
        const cityService = new CityService();
        const paths = await cityService.getCityPaths({
          signal: controller.signal
        });
        if (isMounted) {
          setCityPaths(paths);
        }
      } catch (error) {
        if (!error.name === 'AbortError') {
          console.error('Error loading city paths:', error);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchCityPaths();

    return () => {
      isMounted = false;
      controller.abort();
    };
  }, []);

  const routes = useMemo(() => [
    {
      path: '/app',
      element: <DashboardLayout />,
      children: [{ path: '', element: <DashboardApp /> }]
    },
    {
      path: '/Info',
      element: <DashboardLayout />,
      children: [{ path: '', element: <Info /> }]
    },
    {
      path: '/analyze',
      element: <DashboardLayout />,
      children: [{ path: '', element: <Analyze /> }]
    },
    {
      path: '/user',
      element: <DashboardLayout />,
      children: [{ path: '', element: <User /> }]
    },
    {
      path: '/DVR',
      element: <DashboardLayout />,
      children: [{ path: '', element: <DVR /> }]
    },
    {
      path: '/MobileDVR',
      element: <DashboardLayout />,
      children: [{ path: '', element: <MobileDVR /> }]
    },
    {
      path: '/Health',
      element: <DashboardLayout />,
      children: [{ path: '', element: <SystemHealth /> }]
    },
    {
      path: '/emissions',
      element: <DashboardLayout />,
      children: [{ path: '', element: <Emissions /> }]
    },
    {
      path: '/Logout',
      element: <DashboardLayout />,
      children: [{ path: '', element: <Logout /> }]
    },
    {
      path: '/',
      element: <LogoOnlyLayout />,
      children: [
        { path: 'login', element: <Login /> },
        { path: 'carbonemission', element: <Emissions /> },
        { path: 'drivescore', element: <User /> },
        { path: 'register', element: <Register /> },
        { path: '404', element: <NotFound /> },
        { path: '/', element: <Login /> },
        ...cityPaths.map(cityPath => ({
          path: cityPath.path,
          element: <Binging region={cityPath.region} />
        })),
        { path: '*', element: <Navigate to="/404" /> }
      ]
    },
    { path: '*', element: <Navigate to="/404" replace /> },
    { path: 'driverscores', element: <User /> }
  ], [cityPaths]);

  if (loading) {
    return <LoadingSpinner />;
  }

  return useRoutes(routes);
}